<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from "@/store/modules/user";

@Component({
  name: 'App',
  components: {}
})
export default class extends Vue {
  timer: any

  created() {
  }

  handleVisible() {
  }

  destroyed() {
    clearInterval(this.timer)
  }
}
</script>